import Holidays from 'date-holidays';

export default (date) => {
  const holiday = new Holidays();
  holiday.init('US');
  return holiday.isHoliday(date);
};
